import PropTypes from 'prop-types';
import React, { useCallback } from 'react';
import ReactPaginate from 'react-paginate';
import styled from 'styled-components';

import { ICON_ALIASES } from '_constants/icons';
import { theme } from '_constants/theme';
import { hexToRGBA } from '_helpers/theme';

import Icon from 'components/atomic/Icon';

const StyledPaginate = styled(ReactPaginate)`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  list-style-type: none;
  margin-bottom: 0;
  padding: 0;

  li {
    a {
      display: flex;
      justify-content: center;
      align-items: center;

      min-height: 32px;
      min-width: 32px;
      padding: ${theme.spaces.small2X}px;
      margin-left: ${theme.spaces.small2X}px;
      margin-right: ${theme.spaces.small2X}px;

      font-family: 'Inter';
      font-size: ${theme.fontSizes.small}px;
      font-style: normal;
      font-weight: 400;

      &:not([href]):not([class]) {
        color: ${theme.colors.gray.pr};
      }

      &:hover,
      &:not([href]):not([class]):hover {
        background-color: ${hexToRGBA(theme.colors.gray.secondary, 0.08)};
      }
    }

    &.selected {
      a {
        background-color: ${theme.colors.indigo.primary};

        &:not([href]):not([class]) {
          color: ${theme.colors.white};
        }

        &:not([href]):not([class]):hover {
          background-color: ${theme.colors.indigo.primary};
        }
      }
    }

    &.previous {
      a {
        margin-right: ${theme.spaces.regular}px;
        margin-left: 0;
      }
    }

    &.next {
      a {
        margin-left: ${theme.spaces.regular}px;
        margin-right: 0;
      }
    }

    &.disabled {
      a {
        pointer-events: none;
      }
    }
  }
`;

const Paginate = ({ pageRangeDisplayed, pageCount, currentPage, onPageChange }) => {
  const handlePageChange = useCallback(
    (data) => {
      onPageChange(data.selected + 1);
    },
    [onPageChange]
  );

  return (
    <StyledPaginate
      pageRangeDisplayed={pageRangeDisplayed}
      marginPagesDisplayed={1}
      previousLabel={<Icon alias={ICON_ALIASES.arrowLeft} color={theme.colors.gray.primary} />}
      nextLabel={<Icon alias={ICON_ALIASES.arrowRight} color={theme.colors.gray.primary} />}
      pageCount={pageCount}
      forcePage={currentPage ? currentPage - 1 : 0}
      onPageChange={handlePageChange}
    />
  );
};

Paginate.propTypes = {
  pageRangeDisplayed: PropTypes.number,
  pageCount: PropTypes.number,
  currentPage: PropTypes.number,
  onPageChange: PropTypes.func,
};

export default Paginate;
